<script setup lang="ts">
    const props = defineProps<{
        headline?: string;
        subheadline?: string;
        text?: StoryblokRichtext;
        cta?: ButtonLinkStoryblok[];
    }>();
</script>

<template>
    <div class="content-wrapper">
        <h2>
            <span
                v-if="props.subheadline"
                class="sub-header"
            >
                {{ props.subheadline }}
            </span>
            {{ props.headline }}
        </h2>

        <RichText :doc="props.text" />

        <template v-if="props.cta">
            <StoryblokComponentWrapper
                v-for="button in props.cta"
                :key="button._uid"
                :blok="button"
            />
        </template>
    </div>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/basics/text-content-block.scss';
</style>
